"use client";
//#region packages/@mantine/core/src/components/Input/Input.module.css
var Input_module_default = {
	"wrapper": "m_6c018570",
	"input": "m_8fb7ebe7",
	"bottomSection": "m_93f4ed57",
	"section": "m_82577fc2",
	"placeholder": "m_88bacfd0",
	"root": "m_46b77525",
	"label": "m_8fdc1311",
	"required": "m_78a94662",
	"error": "m_8f816625",
	"success": "m_9d9d40e0",
	"description": "m_fe47ce59"
};
//#endregion
export { Input_module_default as default };

//# sourceMappingURL=Input.module.mjs.map